export const contents = [
  {
    id: 1,
    title: " Learn the Terms",
    link: "ai-agents-guide",
    listing: [
      {
        id: "0",
        title: "Flowcess",
        target:"what-is-flowcess"
      },
      {
        id: "1",
        title: "Process",
        target:"what-is-process"
      },
      // {
      //   id: "2",
      //   title: "Firewall",
      //   target:"what-is-firewall"
      // },
      {
        id: "3",
        title: "AI Agent",
        target:"what-is-ai-agent"
      },
      {
        id: "4",
        title: "AI Studio",
        target:"advanced-ai-studio-platform"
      },
      // {
      //   id: "5",
      //   title: "AI Coworker",
      //   target:"what-is-ai-coworker"
      // },
    ],
  },
  {
    id: 2,
    title: "Permission Guide ",
    link: "ai-agents-permissions",
    listing: [
      {
        id: "0",
        title: "Workspace Roles & Permissions",
        target:"roles-workspace"
      },
      {
        id: "1",
        title: "Project Roles & Permissions",
        target:"roles-projects"
      },
      {
        id: "2",
        title: "CRM Roles & Permissions",
        target:"roles-crm"
      }
    ],
  },
  {
    id: 3,
    title: "App Directory",
    link: "ai-agents-how-to-integrate-app",
    listing: [
      {
        id: "0",
        title: "What is App Directory?",
        target: "app-directory",
    },
    {
        id: "1",
        title: "How to Create Anydone App?",
        target: "how-to-create-anydone-app",
    },
    {
        id: "2",
        title: "AIChat",
        target: "aichat",
    },
    {
        id: "3",
        title: "How to Integrate Mail Service?",
        target: "how-to-integrate-mail-service",
    },
    {
        id: "4",
        title: "How to integrate Slack?",
        target: "how-to-integrate-slack",
    },
    {
        id: "5",
        title: "How to Create a Live Capture App?",
        target: "how-to-create-a-live-capture-app",
    },
    {
        id: "6",
        title: "How to Integrate Messenger?",
        target: "how-to-integrate-messenger",
    },
    {
        id: "7",
        title: "How to Integrate GitHub",
        target: "how-to-integrate-github",
    },
    {
        id: "8",
        title: "How to Integrate WhatsApp?",
        target: "how-to-integrate-whatsapp",
    }
    ],
  },
  
  {
    id: 4,
    title: " Automation Tools(AI)",
    link: "ai-agents-tools",
    listing: [
      {
        id: "0",
        title: "Intent Collection",
        target:"intent-collection"
      },
      {
        id: "1",
        title: "Entity",
        target:"entity"
      },
      {
        id: "2",
        title: "Knowledge Base",
        target:"knowledge-base"

      },
      {
        id: "3",
        title: "What is Prompt ?",
        target:"what-is-prompt"
      },
      {
        id: "4",
        title: "Knowledge Engine",
        target:"knowledge-engine"
      },
      {
        id: "5",
        title: "Flowcess",
        target:"flowcess"
      },
      
    ],
  },
  {
    id: 5,
    title: "Automation  Tool (Process) ",
    link: "ai-agent",
    listing: [
      {
        id: "0",
        title: "Ticket Create",
        target: "how-to-build-auto-tickets-create",
      },
      {
        id: "1",
        title: "Text to Speech",
        target:"how-to-create-text-to-speech"
      },
      {
        id: "2",
        title: "Speech to Text",
        target:"how-to-create-speech-to-text"
      },
      {
        id: "3",
        title: "OCR",
        target:"how-to-create-ocr"
      },
      {
        id: "4",
        title: "Grammar Check",
        target:"how-to-create-grammar-check"
      },
      {
        id: "5",
        title: "Translation",
        target:"how-to-create-translation"
      },
      {
        id: "6",
        title: "Text Summarization",
        target:"how-to-create-text-summarization"
      },
      {
        id: "7",
        title: "Object Detection",
        target:"how-to-create-object-detection"
      },
      {
        id: "8",
        title: "Face Detection",
        target:"how-to-create-face-detection"
      },
      {
        id: "9",
        title: "Face Recognition",
        target:"how-to-create-face-recognition"
      },
      {
        id: "10",
        title: "Image comparison",
        target:"how-to-create-image-comparision"
      },
      {
        id: "11",
        title: "Image generation",
        target:"how-to-create-image-generation"
      },
      {
        id: "12",
        title:"Image Understanding",
        target:"how-to-create-image-comparision"
      },
      {
        id: "13",
        title:"Text Generation",
        target:"how-to-create-text-generation"
      },
      {
        id: "14",
        title:"Code Generation",
        target:"how-to-create-code-generation"
      },
      // {
      //   id: "15",
      //   title:"API",
      //   target:"how-to-create-api"
      // },
      // {
      //   id: "16",
      //   title:"Lookup",
      //   target:"how-to-create-lookup"
      // },
      // {
      //   id: "17",
      //   title:"WASM",
      //   target:"how-to-create-webassembly"
      // },
      // {
      //   id: "18",
      //   title:"IR",
      //   target:"how-to-create-information-retrieval"
      // },
     
    ],
  },
];
